import React from "react";

// {
//     "name": "Regular Coffee",
//     "description": "",
//     "pricing": [
//       {
//         "price": 2.25,
//         "currency": "USD",
//         "priceString": "$2.25"
//       }
//     ],
//     "price": 2.25
//   }

export const MenuItem = (props) => {
  const item = props.item;
  return (
    <div className="row bg-transparent list-group-item d-flex justify-content-between align-items-center">
      <div className="col-10">
        <p className="text-primary">{item.name} </p>
        <p className="">{item.description} </p>
      </div>
      <div className="col-2">
            <span className="badge bg-primary rounded-pill justify-content-between align-items-center">
          ${item.price}
        </span>
      </div>
    </div>
  );
};
